export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/direction.58a6d455.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};